import GrayHeaderCard from "../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import {Grid, Typography} from "@material-ui/core";
import TipologiaApnSubtable from "./tipologia-apn-subtable/TipologiaApnSubtable";
import {useSelector} from "react-redux";

const TipologiaApnTable = () => {
    const dedicatoTable = useSelector(state => state.contrattoDigitaleReducer.apnLists.data.apnDedicato)
    const condivisoTable = useSelector(state => state.contrattoDigitaleReducer.apnLists.data.apnCondiviso)
    const loading = useSelector(state => state.contrattoDigitaleReducer.apnLists.loading)

    return (
        <GrayHeaderCard title={<Typography variant={"subtitle1"}>Tipologia APN</Typography>}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TipologiaApnSubtable tableData={dedicatoTable}
                                          title={"Dedicato"}
                                          loading={loading}/>
                </Grid>
                <Grid item xs={12}>
                    <TipologiaApnSubtable tableData={condivisoTable}
                                          title={"Condiviso"}
                                          loading={loading}/>
                </Grid>
            </Grid>
        </GrayHeaderCard>
    )
}

export default TipologiaApnTable;